<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl
						? `transaction/payment-received/${inputs.id}`
						: `transaction/payment-received`
				"
			>
				<!-- Invoice -->
				<div class="form-group row align-items-center">
					<label for="inputs_invoice_fk" class="col-sm-3 mb-0">
						Invoice
					</label>
					<app-input
						id="inputs_invoice_fk"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="3"
						v-model="input_invoice_fk"
						@input="setInvoiceFkValue"
						fetch-url="transaction/invoice?status=Processed"
						placeholder="Invoice"
						list-value-field="invoice_no"
						:required="true"
					/>
				</div>

				<!-- Billing Value -->
				<div class="form-group row align-items-center">
					<label for="inputs_billing_value" class="col-sm-3 mb-0">
						Billing Value
					</label>
					<app-input
						id="inputs_billing_value"
						class="col-sm-9"
						type="currency-right"
						v-model="billing_value"
						placeholder="Billing Value"
						:disabled="true"
					/>
				</div>

				<!-- Bank Account -->
				<div class="form-group row align-items-center">
					<label for="inputs_bank_account_id" class="col-sm-3 mb-0">
						Bank Account
					</label>
					<app-input
						id="inputs_bank_account_id"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_bank_account_id"
						@input="setBankAccountIdValue"
						fetch-url="master/bank-account?is_active=true"
						placeholder="Bank Account"
						list-value-field="bank_account_virtual_no"
						:required="true"
						:disabled="true"
					/>
				</div>

				<!-- Received Date -->
				<div class="form-group row align-items-center">
					<label for="inputs_received_date" class="col-sm-3 mb-0">
						Received Date
					</label>
					<app-input
						id="inputs_received_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.received_date"
						:placeholder="'Received Date'"
						:required="true"
						:disabled="billing_value_ori == 0"
					/>
				</div>

				<!-- Received Value -->
				<div class="form-group row align-items-center">
					<label for="inputs_received_value" class="col-sm-3 mb-0">
						Received Value
					</label>
					<app-input
						id="inputs_received_value"
						class="col-sm-9"
						type="currency-right"
						v-model="inputs.received_value"
						:placeholder="'Received Value'"
						:required="true"
						:disabled="billing_value_ori == 0"
					/>
				</div>

				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
				<div class="form-group row align-items-center" />
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";

export default {
	name: "ModalForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					id: "",
					name: "",
				};
			},
		},
		tableId: String,
		formId: String,
	},
	data() {
		return {
			preloader: false,
			inputs: {
				received_value: this.formattedIDR(0),
			},
			billing_value: this.formattedIDR(0),
			billing_value_ori: 0,
			input_invoice_fk: this.value
				? this.value.data
					? {
							id: this.value.data.id || 0,
							invoice_no: this.value.data.invoice_no || "",
							request_no: this.value.data.request_no || "",
					  }
					: {
							id: this.value.data?.id || 0,
							invoice_no: this.value.data?.invoice_no || "",
							request_no: this.value.data?.request_no || "",
					  }
				: {
						id: this.value.data.id || 0,
						invoice_no: this.value.data.invoice_no || "",
						request_no: this.value.data.request_no || "",
				  },
			input_bank_account_id: this.value
				? this.value.data
					? {
							id: this.value.data.id || 0,
							bank_account_virtual_no:
								this.value.data.bank_account_virtual_no || "",
					  }
					: {
							id: this.value.data?.id || 0,
							bank_account_virtual_no:
								this.value.data?.bank_account_virtual_no || "",
					  }
				: {
						id: this.value.data.id || 0,
						bank_account_virtual_no:
							this.value.data.bank_account_virtual_no || "",
				  },
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			this.inputs.received_date = this.inputs.received_date
				? this.formattedDate(this.inputs.received_date)
				: this.formattedDate(new Date());
			this.inputs.source_id = 0;
			if (this.selectedUrl) {
				this.inputs.invoice_fk = this.inputs.invoice_fk?.id || 0;
				this.inputs.bank_account_id =
					this.inputs.bank_account_id?.id || 0;
			}

			// remove IDR format from received value
			this.inputs.received_value = this.inputs.received_value.replace(
				/\D/g,
				""
			);
			if (!(this.inputs.received_value == this.billing_value_ori)) {
				this.$toastr.e("Received value must be equal to billing value");
				return;
			}

			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			this.inputs = response.data;
			this.input_invoice_fk = {
				id: response.data.invoice_fk?.id || 0,
				invoice_no: response.data.invoice_fk?.invoice_no || "",
				request_no: response.data.invoice_fk?.request_no || "",
			};
			this.input_bank_account_id = {
				id: response.data.bank_account_id?.id || 0,
				bank_account_virtual_no:
					response.data.bank_account_id?.bank_account_virtual_no ||
					"",
			};
			this.preloader = false;
		},
		setInvoiceFkValue(data) {
			this.inputs.invoice_fk = this.inputs.invoice_fk;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.invoice_fk = data.id;

				this.billing_value = this.formattedIDR(data.grand_total);
				this.billing_value_ori = data.grand_total;

				this.input_bank_account_id = {
					id: data.bank_account_id?.id || 0,
					bank_account_virtual_no:
						data.bank_account_id?.bank_account_virtual_no || "",
				};
				this.inputs.bank_account_id = data.bank_account_id?.id || 0;
			}
		},
		setBankAccountIdValue(data) {
			this.inputs.bank_account_id = this.inputs.bank_account_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.bank_account_id = data.id;
			}
		},
		formattedIDR(value) {
			// Format the value as IDR
			return new Intl.NumberFormat("id-ID", {
				style: "currency",
				currency: "IDR",
				minimumFractionDigits: 0,
			}).format(value);
		},
		formattedDate(payloadDate) {
			const originalDate = payloadDate;
			const date = new Date(originalDate);

			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
			const day = date.getDate().toString().padStart(2, "0");

			const formattedDate = `${year}-${month}-${day}`;

			return formattedDate;
		},
	},
	watch: {
		"inputs.received_value": function (value) {
			if (value) {
				value = parseFloat(value.replace(/\D/g, ""));
				this.inputs.received_value = this.formattedIDR(
					parseFloat(isNaN(value) ? 0 : value)
				);
			}
		},
	},
};
</script>
